export default __webpack_public_path__ + "static/media/pet-boarding.511c7abf.svg";